const MS_PER_DAY = 24 * 60 * 60 * 1000

export const computeForecastDay = (dayParam: string): number | undefined => {
  if (!dayParam || !/^\d{4}-\d{2}-\d{2}$/.test(dayParam)) {
    return undefined
  }

  const targetDate = new Date(`${dayParam}T00:00:00Z`)
  if (isNaN(targetDate.getTime())) {
    return undefined
  }

  const now = new Date()
  const todayUtc = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  const diffDays = Math.round((targetDate.getTime() - todayUtc) / MS_PER_DAY)

  if (diffDays < 0 || diffDays > 6) {
    return undefined
  }

  return diffDays
}

export function useUrlParams() {
  // Deep linking support
  const loadFromUrlParams = () => {
    const urlParams = new URLSearchParams(window.location.search)

    const urlLocation = urlParams.get('location')
    const urlCountryCode = urlParams.get('country_code')
    const urlLanguage = urlParams.get('language')
    const urlLength = urlParams.get('length')

    const urlDay = urlParams.get('day')
    // Push deep links (#155) emit `when=today|tomorrow` rather than an ISO
    // date because the notification could be tapped any time after firing
    // and we want the day relative to *tap time*, not send time.
    const urlWhen = urlParams.get('when')

    const updates: {
      location?: string
      countryCode?: string
      language?: string
      textLength?: number
      forecastDay?: number
    } = {}

    if (urlLocation) {
      updates.location = decodeURIComponent(urlLocation)
      localStorage.setItem('location', updates.location)
    }

    if (urlCountryCode) {
      updates.countryCode = decodeURIComponent(urlCountryCode)
      localStorage.setItem('countryCode', updates.countryCode)
    }

    if (urlLanguage) {
      updates.language = urlLanguage
      localStorage.setItem('language', updates.language)
    }

    if (urlLength) {
      const lengthNum = Number(urlLength)
      if (!isNaN(lengthNum) && lengthNum > 0) {
        updates.textLength = lengthNum
        localStorage.setItem('textLength', lengthNum.toString())
      }
    }

    if (urlDay) {
      const computedDay = computeForecastDay(urlDay)
      if (computedDay !== undefined) {
        updates.forecastDay = computedDay
      }
    }

    if (updates.forecastDay === undefined && urlWhen) {
      if (urlWhen === 'today') updates.forecastDay = 0
      else if (urlWhen === 'tomorrow') updates.forecastDay = 1
    }

    // Clear URL parameters after loading them
    if (urlLocation || urlCountryCode || urlLanguage || urlLength || urlDay || urlWhen) {
      const newUrl = window.location.pathname
      window.history.replaceState({}, document.title, newUrl)
    }

    return updates
  }

  return {
    loadFromUrlParams
  }
} 